import { DraggableProvided, DraggableStateSnapshot } from '@hello-pangea/dnd'
import { CSSProperties, memo, useCallback } from 'react'
import { LiveField } from '../../rapid-ui'
import { DragHandle } from '../form-simulator/drag-handle'

export type AdditionalQuestionOptionRowProps = {
	questionId: string
	option: { id: string; label: string }
	optionIndex: number
	isMultiSelect: boolean
	provided: DraggableProvided
	snapshot: DraggableStateSnapshot
	onLabelChange: (questionId: string, optionId: string, label: string) => void
	onDelete: (questionId: string, optionId: string) => void
}

export const AdditionalQuestionOptionRow = memo(function AdditionalQuestionOptionRow({
	questionId,
	option,
	isMultiSelect,
	provided,
	snapshot,
	onLabelChange,
	onDelete,
}: AdditionalQuestionOptionRowProps) {
	const handleLabelChange = useCallback(
		(value: string) => onLabelChange(questionId, option.id, value),
		[onLabelChange, questionId, option.id],
	)

	const handleDelete = useCallback(
		() => onDelete(questionId, option.id),
		[onDelete, questionId, option.id],
	)

	return (
		<div
			ref={provided.innerRef}
			{...provided.draggableProps}
			style={{
				userSelect: 'none' as const,
				...provided.draggableProps.style,
			} as CSSProperties}
			className="relative group/option mb-2"
		>
			<div className="flex flex-row items-start gap-3 relative">
				<div
					{...provided.dragHandleProps}
					className="mt-0.5 ml-3 size-5 text-transparent group-hover/option:text-grey-500 flex items-center justify-center"
				>
					<DragHandle />
				</div>
				<div className="relative pt-1">
					<div
						className={`size-4 ring-2 ring-purple-400 ${isMultiSelect ? 'rounded' : 'rounded-full'}`}
					/>
				</div>
				<div className="flex-1">
					<LiveField fitSize={false} value={option.label} onChange={handleLabelChange} />
				</div>
				<button
					className="text-red-500 text-sm hover:bg-red-100 px-2.5 py-1 rounded cursor-pointer opacity-0 group-hover/option:opacity-100 transition-opacity"
					onClick={handleDelete}
				>
					&minus;
				</button>
			</div>
		</div>
	)
})
